// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/strings/v5.0.0/src/Data/String/Unsafe.js");
module.exports = {
    "char": $foreign["char"],
    charAt: $foreign.charAt
};
